import { Eye, EyeOff } from 'lucide-react';
import { Button } from './button';
import { useDataVisibility } from '@/contexts/DataVisibilityContext';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

interface VisibilityToggleProps {
  className?: string;
}

export const VisibilityToggle = ({ className }: VisibilityToggleProps) => {
  const { isVisible, toggleVisibility } = useDataVisibility();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          onClick={toggleVisibility}
          className={className}
          aria-label={isVisible ? 'Ocultar valores' : 'Mostrar valores'}
        >
          {isVisible ? (
            <Eye className="h-4 w-4" />
          ) : (
            <EyeOff className="h-4 w-4" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {isVisible ? 'Ocultar valores' : 'Mostrar valores'}
      </TooltipContent>
    </Tooltip>
  );
};
